import { z } from 'zod';

export const registerSchema = z
  .object({
    email: z.string().email(),
    password: z.string().min(1),
    confirm_password: z.string().min(1),
  })
  .refine((d) => d.password === d.confirm_password, {
    path: ['confirm_password'],
    message: 'passwords_must_match',
  });

export type RegisterInput = z.infer<typeof registerSchema>;
